import { render, staticRenderFns } from "./GeneratorMarket.vue?vue&type=template&id=6f04e68c&scoped=true"
import script from "./GeneratorMarket.vue?vue&type=script&lang=js"
export * from "./GeneratorMarket.vue?vue&type=script&lang=js"
import style0 from "./GeneratorMarket.vue?vue&type=style&index=0&id=6f04e68c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f04e68c",
  null
  
)

export default component.exports